"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOwner = void 0;
var isOwner = exports.isOwner = function isOwner(transitionable, userId, roleId) {
  var _a;
  return ((_a = transitionable.transition.owners) === null || _a === void 0 ? void 0 : _a.find(function (el) {
    return el.individual === userId || el.actor === roleId;
  })) !== undefined;
};